import { useCallback, useContext } from 'react'
import * as React from 'react'
import ModalContext from 'contexts/ModalContext'
import { SiteTakeoverCampaignTagLabelCore } from './SiteTakeoverCampaignTagLabelCore'
import type { SiteTakeoverCampaignTagLabelProps } from './siteTakeoverCampaignTagLabel.types'

export { LABEL_HEIGHT, LabelElement } from './SiteTakeoverCampaignTagLabelCore'

/**
 * This is a base 'abstract' label that is used by all the *implementation labels*
 * This should never be used directly. Talk to your designer to discover the correct
 * label type to use in the event you are unsure.
 */
export const SiteTakeoverCampaignTagLabel = React.forwardRef<HTMLSpanElement, SiteTakeoverCampaignTagLabelProps>((props, ref) => {
  const showModal = useContext(ModalContext)

  const openCampaignModal = useCallback(() => {
    import('./SiteTakeoverCampaignModal').then(({ default: SiteTakeoverCampaignModal }) => {
      showModal(<SiteTakeoverCampaignModal />)
    })
  }, [showModal])

  return (
    <SiteTakeoverCampaignTagLabelCore
      {...props}
      ref={ref}
      openCampaignModal={openCampaignModal}
    />
  )
})
